import { create, w } from '@dojo/framework/core/vdom';
import { createICacheMiddleware } from '@dojo/framework/core/middleware/icache';
import { theme } from '@dojo/framework/core/middleware/theme';

import { SlidingPane } from '@holmescorp/base-widgets/sliding-pane';

// make generated .d.ts file valid
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { WNodeFactory, WidgetProperties, DNode } from '@dojo/framework/core/interfaces';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { ThemeProperties } from '@dojo/framework/core/middleware/theme';

import { subscribe } from 'pub-sub';
import { createNlsMiddleware, lccstate, registry } from 'lcc-state';
import { delay } from '@holmescorp/common';
import { viewport } from '../support/viewport';

interface EvalPaneIcache {
	open: boolean;
	aboutToOpen: boolean;
}

export interface EvalPaneProperties {
	onClose?: () => void;
}

const icache = createICacheMiddleware<EvalPaneIcache>();
const nls = createNlsMiddleware('settings');
const factory = create({
	icache,
	theme,
	nls,
	lccstate
}).properties<EvalPaneProperties>();

export const EvalPane = factory(({ properties, middleware: { icache, nls } }) => {
	const { onClose } = properties();
	icache.getOrSet('aboutToOpen', false);
	const open = icache.getOrSet('open', () => {
		subscribe('eval/open', async () => {
			icache.set('aboutToOpen', true);
			await delay(200);
			icache.set('open', true);
		});
		subscribe('close-all/panes', () => {
			icache.set('open', false);
		});
		return false;
	});

	const { vw } = viewport();
	const {
		messages: { evaluation_title = '[settings] evaluation_title' }
	} = nls();
	const key = `eval-pane`;
	const xqa = `eval-pane-${open}`;

	return w(
		SlidingPane,
		{
			xqa,
			key,
			open,
			align: 'right',
			underlay: true,
			title: evaluation_title,
			width: Math.min(vw, 1024),
			onRequestClose: () => {
				icache.set('open', false);
				icache.set('aboutToOpen', async () => {
					await delay(500);
					return true;
				});
				onClose && onClose();
			}
		},
		[
			w('ResourceCenter', {
				baseurl: '/common/feedback/evaluation/',
				url: { '/common/feedback/evaluation/': '/common/feedback/evaluation/' }
			})
		]
	);
});

registry.define('EvalPane', EvalPane);
